import React from 'react';
import PropTypes from 'prop-types';

import IconRemove from '../../cart/svg/IconRemove';

function ColumnDeleteAction({ width, onClick, style }) {
  return (
    <div className={'column-extra-action cart-remove'} style={{ width, textAlign: `-webkit-center`, cursor: 'pointer', zIndex: 50, ...style}} onClick={onClick}>
      <IconRemove size={20} />
    </div>
  )
}

ColumnDeleteAction.propTypes = {
  width: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
}

export default ColumnDeleteAction;
